module.exports = __webpack_public_path__ + "img/music_023.d911f4f2.png";